module.exports = "/images/subscription_success.svg?735be87307121189f71f602abb369ce8";